module.exports = __webpack_public_path__ + "img/level_five_hover.bc80b1b3.png";